import {List} from 'immutable';
import {assignmentExtensions} from 'resources/augmented/Assignment/assignment.extensions';

interface IdsToSelect {
  classroomId?: string;
  studentId?: string;
}

const draftAssignmentExtensions = {
  /**
   * @see assignmentExtensions.getStartDateFromSettings
   */
  getStartDateFromSettings: assignmentExtensions.getStartDateFromSettings,
  /**
   * @see assignmentExtensions.getDueDateFromSettings
   */
  getDueDateFromSettings: assignmentExtensions.getDueDateFromSettings,
  /**
   * @see assignmentExtensions.getIsAllowLateSubmissionsFromSettings
   */
  getIsAllowLateSubmissionsFromSettings: assignmentExtensions.getIsAllowLateSubmissionsFromSettings,
  /**
   * @see assignmentExtensions.getIsRandomizeQuestionsFromSettings
   */
  getIsRandomizeQuestionsFromSettings: assignmentExtensions.getIsRandomizeQuestionsFromSettings,
  /**
   * @see assignmentExtensions.getTimeLimitFromSettings
   */
  getTimeLimitFromSettings: assignmentExtensions.getTimeLimitFromSettings,
  /**
   * @see assignmentExtensions.getCorrectAnswerSettingFromSettings
   */
  getCorrectAnswerSettingFromSettings: assignmentExtensions.getCorrectAnswerSettingFromSettings,
  /**
   * @see assignmentExtensions.getMessageFromSettings
   */
  getMessageFromSettings: assignmentExtensions.getMessageFromSettings,
  /**
   * @see assignmentExtensions.getLtiLineItemIdFromSettings
   */
  getLtiLineItemIdFromSettings: assignmentExtensions.getLtiLineItemIdFromSettings,
  /**
   * @see assignmentExtensions.getIsAutoAssignNewClassroomEnrolleesFromSettings
   */
  getIsAutoAssignNewClassroomEnrolleesFromSettings:
    assignmentExtensions.getIsAutoAssignNewClassroomEnrolleesFromSettings,
  /**
   * @see assignmentExtensions.getLockdownModeEnabledFromSettings
   */
  getLockdownModeEnabledFromSettings: assignmentExtensions.getLockdownModeEnabledFromSettings,
  getSettingsFromRelations(idsToSelect: IdsToSelect = {}) {
    const {classroomId, studentId} = idsToSelect;

    // student settings should always be returned first
    if (studentId) {
      const students = this.getStudents();
      const student = students.find((st) => st.getId() === studentId);
      const studentAssignmentRelationships = student
        .get('relationshipMeta')
        .get('draft_assignment');
      const studentAssignment = studentAssignmentRelationships.get(this.getId());
      const settings = studentAssignment?.get('settings');
      if (settings) {
        return settings;
      }
    }
    if (classroomId) {
      const classrooms = this.getClassrooms().isEmpty()
        ? this.getStudentClassrooms()
        : this.getClassrooms();
      const classroom = (classrooms || List()).find((cr) => cr.getId() === classroomId);
      const classroomAssignment =
        classroom?.getAssignmentRelationships?.(this.getId()) ||
        this.getClassroomRelationships(classroomId);
      const settings = classroomAssignment?.getSettings?.();
      if (settings) {
        return settings;
      }
    }
    return this.getSettings();
  }
};

export {draftAssignmentExtensions};
